import React, { createContext, useContext } from 'react';
import { type LiveFeedTelemetry } from '../analytics/liveFeedTelemetry';

const LiveFeedTelemetryContext = createContext<LiveFeedTelemetry | null>(null);

/** The collector that Live Feed widgets report to, or `null` outside a monitor grid. */
export function useLiveFeedTelemetryCollector(): LiveFeedTelemetry | null {
  return useContext(LiveFeedTelemetryContext);
}

export function LiveFeedTelemetryProvider({
  telemetry,
  children,
}: {
  telemetry: LiveFeedTelemetry;
  children: React.ReactNode;
}) {
  return (
    <LiveFeedTelemetryContext.Provider value={telemetry}>
      {children}
    </LiveFeedTelemetryContext.Provider>
  );
}
